import React, { useEffect, useRef, useState } from "react";
import style from "./WorkflowTemplateFooter.module.scss";
import workflowTemplateStyles from "../../templates/flowbots/WorkflowTemplate.module.scss";
import { getImageUrl } from "../../../commons/assets_path";
import { Loader } from "../../common/Loaders/Loader";
import { NoticeMessage } from "../../templates/flowbots/Notice/NoticeMessage";
import axios from "axios";
import useLanguageChange from "../../../hooks/useLanguageChange";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

type Props = {
  contentableType: string;
  projectNames: Array<[string, number]>;
  sectionId: number;
  totalCount: number;
  clientCode: string;
  locale: string;
};

export const WorkflowTemplateFooter = (props: Props) => {
  const projectListRef = useRef<HTMLDivElement>(null);
  const projectBtnRef = useRef<HTMLButtonElement>(null);
  const [isShowProjectList, setIsShowProjectList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notice, setNotice] = useState({ isShow: false, message: "", type: "" });
  const { t } = useLanguageChange(props.locale);
  const handleClickOutside = (event: MouseEvent) => {
    if (
      projectListRef.current &&
      !projectListRef.current.contains(event.target as Node) &&
      (!projectBtnRef.current || !projectBtnRef.current.contains(event.target as Node))
    ) {
      setIsShowProjectList(false);
    }
  };

  const handleClose = () => {
    const footer = document.querySelector(".workflow-template-footer");
    footer?.setAttribute("style", "display: none;");
    // NOTE: ここでチェックボックスを全て外す処理を行う
    const checkboxes = document.querySelectorAll(".js-section_content_section_id");
    checkboxes.forEach((element) => {
      (element as HTMLInputElement).checked = false;
    });
    const selectAllCheckbox = document.getElementById("js-select_contentable_ids") as HTMLInputElement;
    selectAllCheckbox.checked = false;
  };

  const handleDelete = async () => {
    const selectedCount = document.querySelector(".selected-count") as HTMLElement;
    const confirmMessage = t("選択したテンプレートを削除", { count: Number(selectedCount.textContent) });
    if (window.confirm(confirmMessage)) {
      const checked = document.querySelectorAll(".section-content-item__checkbox:checked");
      const ids: Array<string | null> = [];
      checked.forEach((element) => {
        ids.push(element.getAttribute("workflow_template_id"));
      });
      setIsLoading(true);
      await axios
        .delete(
          `/${props.clientCode}/sections/${props.sectionId}/workflow_templates/${ids[0]}/destroy_selected_templates`,
          {
            data: {
              ids: ids,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            // NOTE: ローカルストレージにres.data.messageを保存し、リロード後に表示している
            localStorage.setItem("workflow_template_notice", res.data.message);
            location.reload();
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            setIsLoading(false);
            setNotice({ isShow: true, message: error.response.data.message, type: "error" });
          } else {
            setIsLoading(false);
            setNotice({
              isShow: true,
              message: t("WorkflowTemplateFooter.フローボットの削除に失敗しました。"),
              type: "error",
            });
          }
        });
    }
  };

  const handleMove = async (projectId: number, projectName: string) => {
    const selectedCount = document.querySelector(".selected-count") as HTMLElement;
    const confirmMessage = t("WorkflowTemplateFooter.選択したテンプレートを移動しますか？", {
      count: Number(selectedCount.textContent),
      projectName: projectName,
    });
    if (window.confirm(confirmMessage)) {
      const checkboxes = document.querySelectorAll(".js-section_content_section_id");
      const sectionContents: Array<{ id: string | null; contentable_id: string | null }> = [];
      checkboxes.forEach((element) => {
        const id = element.getAttribute("section_content_id");
        const contentableId = element.getAttribute("workflow_template_id");
        if ((element as HTMLInputElement).checked) {
          sectionContents.push({ id: id, contentable_id: contentableId });
        }
      });
      setIsLoading(true);
      await axios
        .patch(
          `/${props.clientCode}/sections/${props.sectionId}/update_section_contents?section_contentable_type=WorkflowTemplate`,
          {
            section: {
              section_contents_attributes: sectionContents.reduce(
                (acc: { [key: number]: any }, { id, contentable_id }, index) => {
                  acc[index] = {
                    id: id,
                    section_id: projectId,
                    contentable_id: contentable_id,
                    contentable_type: "WorkflowTemplate",
                  };
                  return acc;
                },
                {},
              ),
              to_section_id: projectId,
              contentable_type: "WorkflowTemplate",
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            if (res.data?.redirect_url) {
              // NOTE: ローカルストレージにres.data.messageを保存し、リロード後に表示している
              localStorage.setItem("workflow_template_notice", res.data.message);
              window.location.href = res.data.redirect_url;
            }
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            setIsLoading(false);
            setNotice({ isShow: true, message: error.response.data.message, type: "error" });
          } else {
            setIsLoading(false);
            setNotice({
              isShow: true,
              message: t("WorkflowTemplateFooter.プロジェクトの移動に失敗しました。"),
              type: "error",
            });
          }
        });
    }
  };

  const handleTerminate = async () => {
    const selectedCount = document.querySelector(".selected-count") as HTMLElement;
    const confirmMessage = t("WorkflowTemplateFooter.選択したフローボットを停止しますか？", {
      count: Number(selectedCount.textContent),
    });
    if (window.confirm(confirmMessage)) {
      const checked = document.querySelectorAll(".section-content-item__checkbox:checked");
      const ids: Array<string | null> = [];
      checked.forEach((element) => {
        ids.push(element.getAttribute("workflow_id"));
      });
      setIsLoading(true);
      await axios
        .delete(`/${props.clientCode}/workflows/terminate_selected_templates`, {
          data: {
            ids: ids,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            // NOTE: ローカルストレージにres.data.messageを保存し、リロード後に表示している
            localStorage.setItem("workflow_template_notice", res.data.message);
            location.reload();
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            setIsLoading(false);
            setNotice({ isShow: true, message: error.response.data.message, type: "error" });
          } else {
            setIsLoading(false);
            setNotice({
              isShow: true,
              message: t("WorkflowTemplateFooter.フローボットの停止に失敗しました。"),
              type: "error",
            });
          }
        });
    }
  };

  // 保留中のフローボットを起動する
  const handleLaunchHeldWorkflow = async () => {
    const selectedCount = document.querySelector(".selected-count") as HTMLElement;
    const confirmMessage = t("WorkflowTemplateFooter.選択したフローボットを起動しますか？", {
      count: Number(selectedCount.textContent),
    });
    if (window.confirm(confirmMessage)) {
      const checked = document.querySelectorAll(".section-content-item__checkbox:checked");
      const ids: Array<string | null> = [];
      checked.forEach((element) => {
        ids.push(element.getAttribute("workflow_id"));
      });
      setIsLoading(true);
      await axios
        .post(`/${props.clientCode}/workflows/boot_held_workflows`, {
          ids: ids,
          is_bulk: false,
          section_id: props.sectionId,
        })
        .then((res) => {
          if (res.status === 200) {
            // NOTE: ローカルストレージにres.data.messageを保存し、リロード後に表示している
            localStorage.setItem("workflow_template_notice", res.data.message);
            window.location.href = res.data.redirect_url;
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            setIsLoading(false);
            setNotice({ isShow: true, message: error.response.data.message, type: "error" });
          } else {
            setIsLoading(false);
            setNotice({
              isShow: true,
              message: t("WorkflowTemplateFooter.フローボットの起動に失敗しました。"),
              type: "error",
            });
          }
        });
    }
  };

  // 保留中のフローボットを停止する
  const handleTerminateHeldWorkflow = async () => {
    const selectedCount = document.querySelector(".selected-count") as HTMLElement;
    const confirmMessage = t("WorkflowTemplateFooter.選択したフローボットを停止しますか？", {
      count: Number(selectedCount.textContent),
    });
    if (window.confirm(confirmMessage)) {
      const checked = document.querySelectorAll(".section-content-item__checkbox:checked");
      const ids: Array<string | null> = [];
      checked.forEach((element) => {
        ids.push(element.getAttribute("workflow_id"));
      });
      setIsLoading(true);
      await axios
        .post(`/${props.clientCode}/workflows/destroy_held_workflows`, {
          ids: ids,
          is_bulk: false,
          section_id: props.sectionId,
        })
        .then((res) => {
          if (res.status === 200) {
            // NOTE: ローカルストレージにres.data.messageを保存し、リロード後に表示している
            localStorage.setItem("workflow_template_notice", res.data.message);
            location.reload();
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            setIsLoading(false);
            setNotice({ isShow: true, message: error.response.data.message, type: "error" });
          } else {
            setIsLoading(false);
            setNotice({
              isShow: true,
              message: t("WorkflowTemplateFooter.フローボットの停止に失敗しました。"),
              type: "error",
            });
          }
        });
    }
  };

  useEffect(() => {
    // ローカルストレージにworkflow_template_noticeがあれば、その内容を取得して表示
    const noticeMessage = localStorage.getItem("workflow_template_notice");
    if (noticeMessage) {
      setNotice({ isShow: true, message: noticeMessage, type: "notice" });
      localStorage.removeItem("workflow_template_notice");
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <>
      <div
        className="workflow-template-footer fixed-bottom align-items-center"
        style={{ zIndex: isLoading ? 9999 : 4 }}
      >
        <div className="d-flex align-items-center" style={{ width: "100%", padding: "24px 80px 24px 36px" }}>
          <div className={style.selectedCount}>
            <span className="selected-count">0</span>
            {t("WorkflowTemplateFooter.件選択中")}
          </div>
          <div className={style.buttonWrap}>
            {props.contentableType === "WorkflowTemplate" && (
              <>
                <button
                  type="button"
                  className={style.normalButton}
                  onClick={() => setIsShowProjectList(!isShowProjectList)}
                  ref={projectBtnRef}
                >
                  <img src={getImageUrl("images/icons/change.svg")} width={20} height={20} />
                  {t("WorkflowTemplateFooter.他プロジェクトに移動")}
                </button>
                {isShowProjectList && (
                  <div className={style.projectList} ref={projectListRef}>
                    {props.projectNames.map((element, i) => {
                      return (
                        <div key={i} className={style.projectLabel} onClick={() => handleMove(element[1], element[0])}>
                          <div
                            className="d-flex justify-content-center align-items-center d-block"
                            style={{
                              backgroundColor: "#f3fafa",
                              border: "solid 1px #dce7e7",
                              width: "20px",
                              height: "20px",
                              borderRadius: "4px",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "11px",
                                fontWeight: "bold",
                                display: "inline-block",
                                marginTop: "0.7px",
                                color: "#32cdc8",
                              }}
                            >
                              {element[0] === t("WorkflowTemplateFooter.マイプロジェクト") ? (
                                <img src={getImageUrl("images/icons/my.png")} width={15} />
                              ) : (
                                <>{element[0].slice(0, 1)}</>
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              width: "100%",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {element[0]}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                <button
                  type="button"
                  className={style.redButton}
                  onClick={handleDelete}
                  data-testid="workflow-template-delete"
                >
                  <img src={getImageUrl("images/icons/trash_red.svg")} width={20} height={20} />
                  {t("WorkflowTemplateFooter.削除")}
                </button>
              </>
            )}
            {props.contentableType === "Workflow" && (
              <>
                <button
                  type="button"
                  className={style.redButton}
                  onClick={handleTerminate}
                  data-testid="workflow-template-terminate"
                >
                  <img src={getImageUrl("images/icons/stop.svg")} width={20} height={20} />
                  {t("WorkflowTemplateFooter.停止")}
                </button>
              </>
            )}
            {props.contentableType === "HeldWorkflow" && (
              <>
                <button type="button" className={style.normalButton} onClick={handleLaunchHeldWorkflow}>
                  <img src={getImageUrl("images/icons/launched_flow_dark.svg")} width={20} height={20} />
                  {t("WorkflowTemplateFooter.起動")}
                </button>
                <button
                  type="button"
                  className={style.redButton}
                  onClick={handleTerminateHeldWorkflow}
                  data-testid="workflow-template-terminate"
                >
                  <img src={getImageUrl("images/icons/stop.svg")} width={20} height={20} />
                  {t("WorkflowTemplateFooter.停止")}
                </button>
              </>
            )}
          </div>
          <div onClick={handleClose} style={{ cursor: "pointer" }}>
            <img src={getImageUrl("images/icons/cancel.svg")} width={20} height={20} />
          </div>
        </div>
        <NoticeMessage notice={notice} setNotice={setNotice} />
        {isLoading && (
          <div className={workflowTemplateStyles.loaderWrapper}>
            <div className={workflowTemplateStyles.loaderContent}>
              <Loader loaderColor="yoom-green" loaderSize={35} />
            </div>
          </div>
        )}
      </div>
      <NoticeMessage notice={notice} setNotice={setNotice} />
    </>
  );
};
